import { BodyLarge400 } from '@nebula/global-styles';
import React from 'react';
import Spinner from '@nebula/spinner';
import PropTypes from 'prop-types';
import { LoaderContainer } from './loader.styles';

const Loader = ({ isWebview, subscriptionName }) => (
  <LoaderContainer isWebview={isWebview}>
    <React.Fragment>
      <Spinner spinnerSize="3rem" />
      <BodyLarge400
        aria-live="polite"
        aria-label={`Cancelling ${subscriptionName} please wait`}
      >{`Cancelling ${subscriptionName}`}</BodyLarge400>
    </React.Fragment>
  </LoaderContainer>
);

Loader.propTypes = {
  isWebview: PropTypes.bool,
  subscriptionName: PropTypes.string,
};

export default Loader;
